// The editor's node views, the parser, the diff schema and the static page all derive a field's wrapper
// from this table, so a field cannot change shape between one rendering and the next.
export const TEMPLATE_FIELD_INLINE_NAME = 'template-field-inline';
export const TEMPLATE_FIELD_BLOCK_NAME = 'template-field-block';
export const TEMPLATE_FIELD_DROPDOWN_NAME = 'template-field-dropdown';

/** Every field kind, and whether it lays out as a block (`div`) or inline (`span`). */
export const TEMPLATE_FIELD_KINDS: ReadonlyArray<{ name: string; block: boolean }> = [
  { name: TEMPLATE_FIELD_INLINE_NAME, block: false },
  { name: TEMPLATE_FIELD_BLOCK_NAME, block: true },
  { name: TEMPLATE_FIELD_DROPDOWN_NAME, block: false },
];

/** All template field node names - the nodes that carry a `data-field-id`. */
export const TEMPLATE_FIELD_NODE_TYPES = TEMPLATE_FIELD_KINDS.map((kind) => kind.name);

export const ALL_TEMPLATE_FIELD_NAMES = new Set(TEMPLATE_FIELD_NODE_TYPES);

/** The class on a field's wrapper element, which is what the stylesheet targets. */
export const templateFieldWrapperClass = (name: string): string => `${name}-wrapper`;
